// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2Npb4","burgerMenuIcon":"Header_burgerMenuIcon__uoHnM"};